module.exports = __webpack_public_path__ + "assets/whatsapp.36717071.svg";